require('./bootstrap');
window.Vue = require('vue').default;
window.axios = require('axios').default;


import 'es6-promise/auto';
import {store} from './store';
import {routes} from './router';
import VueRouter from "vue-router";
import './ml'

Vue.use(require('vue-cookies'))
Vue.use(VueRouter);

import {func} from './dateParse'
Vue.prototype.$func = func;

const router = new VueRouter({
    base: '/administrator/',
    mode: 'history',
    routes
})


const token = Vue.$cookies.get('api_token')
if (token) {
    store.commit('setApiToken', token)
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 403) {
        store.commit('setNotification', {
            type: 'error',
            message: error.response.data.message
        })
        router.push({name: 'permission.denied'})
    }
    if (error.response.status === 401) {
        store.dispatch('AUTH_LOGOUT')
        router.push({name: 'auth.login'})
    }
    return error;
});
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

const app = new Vue({
    store,

    mounted() {

    },
    methods: {

    },

    router,
}).$mount('#app')
